import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

const FOOTER_LINKS = [
  { path: '/', label: 'Home' },
  ...ROUTES
    .filter((r) => !r.requiresAuth && !r.is_hidden)
    .map((r) => ({ path: r.path, label: r.displayTitle })),
];

function SectionFooter() {
  const location = useLocation();
  const currentBase = '/' + location.pathname.split('/')[1];

  return (
    <div className="section-footer">
      <div className="section-footer-links">
        {FOOTER_LINKS.map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            className={path === currentBase ? 'active' : ''}
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default SectionFooter;
